import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MdbModalRef } from 'mdb-angular-ui-kit/modal';
import { finalize } from 'rxjs';

import { ModalComponent } from '../../../utils/modal/modal.component';
import { LocationService } from '../../../../services/resources/location.service';
import { LocationModel } from '../../../../models/resources/location.model';
import { HttpErrorsService } from '../../../../services/utils/http-errors.service';
import { AddressFormComponent } from '../../../forms/address-form/address-form.component';

@Component({
  selector: 'app-new-location-modal',
  imports: [ AddressFormComponent, ModalComponent ],
  templateUrl: './new-location-modal.component.html',
  styleUrl: './new-location-modal.component.scss',
})
export class NewLocationModalComponent {
  loading: boolean = false;
  formGroup: FormGroup | undefined;

  constructor(
    private modalRef: MdbModalRef<NewLocationModalComponent>,
    private httpErrorService: HttpErrorsService,
    private locationService: LocationService
  ) {}

  submit() {
    this.formGroup!.markAllAsTouched();

    if (this.formGroup!.invalid)
      return;

    this.loading = true;

    let resource = {
      ...this.formGroup!.value,
      latitude: Number(
        this.formGroup!.value.latitude?.toString().replace(',', '.')
      ),
      longitude: Number(
        this.formGroup!.value.longitude?.toString().replace(',', '.')
      ),
    };

    this.locationService
    .create(resource)
    .pipe(finalize(() => (this.loading = false)))
    .subscribe({
next: (location: LocationModel) => {
        this.modalRef.close(location);
      },
      error: (e) => {
        this.httpErrorService.handleError(e);
      },
    });
  }

  getValueOf(controlName: string) {
    return this.formGroup?.get(controlName)?.value;
  }
}
